import { Controller } from "@hotwired/stimulus"
import LocalTime from "local-time"

export default class extends Controller {
  toggle(event) {
    event.stopPropagation()
    if (this.element.dataset.toggled) {
      delete this.element.dataset.toggled
      this.element.removeAttribute("data-localized")
      LocalTime.process(this.element)
    } else {
      this.element.dataset.toggled = true
      this.element.setAttribute("data-localized", "")
      this.element.textContent = this.element.title
    }
  }
}
